import React from 'react';
import { Link, useRoute } from 'wouter';

import { SidebarMenuButton, SidebarMenuItem, useSidebar } from '../ui/sidebar';
import { useIsMobile } from '../../hooks/use-mobile';
import { useContextRouting } from '../../hooks/useContextRouting';

interface NavItem {
  title: string;
  href: string;
  icon: React.ElementType;
}

interface SidebarNavItemProps {
  item: NavItem;
}

export const SidebarNavItem: React.FC<SidebarNavItemProps> = React.memo(
  ({ item }) => {
    const { currentContextId, currentPath } = useContextRouting();
    const { setOpenMobile } = useSidebar();
    const isMobile = useIsMobile();
    
    // Build context-aware href
    const contextHref = currentContextId ? `/context/${currentContextId}${item.href}` : item.href;
    
    // Check if current route is active
    const [isActive] = useRoute(contextHref);
    const [isNestedActive] = useRoute(`${contextHref}/:rest*`);
    const isPathActive = currentPath === item.href;

    const handleClick = () => {
      // Close sidebar on mobile when navigating
      if (isMobile) {
        setOpenMobile(false);
      }
    };

    return (
      <SidebarMenuItem key={item.title}>
        <SidebarMenuButton asChild isActive={isActive || isNestedActive || isPathActive}>
          <Link to={contextHref} onClick={handleClick}>
            <item.icon className="h-4 w-4" />
            <span>{item.title}</span>
          </Link>
        </SidebarMenuButton>
      </SidebarMenuItem>
    );
  }
);
